export class ClaimType {
  constructor({ id, name, status, version, claim_type_steps: claimTypeSteps }) {
    this.id = id;
    this.name = name;
    this.status = status;
    this.version = version;
    this.claimTypeSteps = claimTypeSteps.map(
      claimTypeStep => new ClaimTypeStep(claimTypeStep)
    );
  }
}

export class ClaimTypeStep {
  constructor({
    id,
    name,
    sort_order: sortOrder,
    claim_type_step_items: claimTypeStepItems,
  }) {
    this.id = id;
    this.name = name;
    this.sortOrder = sortOrder;
    this.claimTypeStepItems = claimTypeStepItems.map(
      claimTypeStepItem => new ClaimTypeStepItem(claimTypeStepItem)
    );
  }
  addClaimTypeStepItem(claimTypeStepItem) {
    this.claimTypeStepItems.push(claimTypeStepItem);
  }
}
export class ClaimTypeStepItem {
  constructor({ id, mandatory, sort_order: sortOrder, claim_item: claimItem }) {
    this.id = id;
    this.mandatory = mandatory;
    this.sortOrder = sortOrder;
    this.claimItem = claimItem ? new ClaimItem(claimItem) : null;
  }
}

export class ClaimItem {
  constructor({
    id,
    name,
    input_type: inputType,
    choices,
    description_insurer: descriptionInsurer,
    description_owner: descriptionOwner,
  }) {
    this.id = id;
    this.name = name;
    this.inputType = inputType;
    this.choices = choices;
    this.descriptionInsurer = descriptionInsurer;
    this.descriptionOwner = descriptionOwner;
  }
}

export class ClaimTemplateService {
  getClaimTypeClass() {
    return ClaimType;
  }
  getClaimTypeStepClass() {
    return ClaimTypeStep;
  }
  getClaimTypeStepItemClass() {
    return ClaimTypeStepItem;
  }
  getClaimItemClass() {
    return ClaimItem;
  }
}

export default new ClaimTemplateService();
